import React, { useState, useEffect, useMemo, useCallback } from "react";
import moment from "moment";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import InfoIcon from "@mui/icons-material/Info";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import PreviewIcon from "@mui/icons-material/Preview";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Modal, useMediaQuery, Table, TableBody, TableCell, TableContainer, TableHead, FormControlLabel, Checkbox, TableRow, TablePagination, Button, Grid, TextField, IconButton, Tooltip, Box, Tabs, Tab, Chip, Menu, MenuItem, Badge, Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BASE_URL, DISABLED_MODULE } from "./../../global";
import { useTheme } from "@mui/material/styles";
import { paginationrowsPerPageOptions } from "../../constants/commonConst";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { checkDSStatusByCount } from "../srf/countTester";
import InfoModal from "./infoModal";
import { locationOptions } from "../../constants/srfConstants";
import ListWrap from "../commonComponent/listWrap";
import MultipleJobAssignButton from "./editDatasheet/mulipleJobAssign";
import { certificateStatusUpdate, datasheetsApprove, datashettAprroveWithdrawl } from "./editDatasheet/submitHandlers";
import CalibrationStartEndTimeModal from "./editDatasheet/calibrationStartEndTimeModal";
import { getFormattedDates } from "../../utils/utils";
import { DateisValid, parseRange } from "../../utils/components/accuracyandlcandrangesshow";

/*  1. "Sent for Approval" is derived from `cert.status`:
 *  cert.status = 3  -> Sent for Approval   (matches the existing `disabled={row.certStatus == 3} and cert.approvedBy is null`  check that was
 * 2. "Calibration Location" (Onsite / Lab / In House) is mapped to the  */
const CERT_STATUS_SENT_FOR_APPROVAL = 3;
const CALIBRATION_STATUS_CASE = `(CASE WHEN (ds.totalReadings IS NULL OR ds.totalReadings = 0) THEN 'Uncalibrated' ELSE 'Calibrated' END)`;
const APPROVAL_STATUS_CASE = `(CASE
    WHEN ds.datasheetApprovedBy IS NOT NULL THEN 'Approved'
    WHEN cert.status = ${CERT_STATUS_SENT_FOR_APPROVAL} AND cert.approvedBy IS NULL THEN 'Sent for Approval'
    WHEN (ds.totalReadings IS NOT NULL AND ds.totalReadings > 0) THEN 'Pending Approval'
    ELSE NULL END)`;

// Top-level tabs
const MAIN_TABS = [
  { key: "all", label: "All Datasheets" },
  { key: "pending", label: "Action Pending" },
  { key: "approved", label: "Approved" },
];

// Status filter shown only on the "All Datasheets" tab
const STATUS_FILTER_OPTIONS = ["Uncalibrated", "Calibrated", "Approved"];

// Sub-tabs, only shown under "Action Pending"
const SUB_TABS = [
  { key: "all", label: "All" },
  { key: "uncalibrated", label: "Uncalibrated" },
  { key: "pendingApproval", label: "Pending Approval" },
  { key: "sentForApproval", label: "Sent for Approval" },
];

const STATUS_CHIP_STYLES = {
  Calibrated: { color: "success" },
  Uncalibrated: { color: "error" },
  Approved: { color: "info" },
  "Pending Approval": { color: "warning" },
  "Sent for Approval": { color: "secondary" },
};

const toolbarFieldSx = {
  flex: {
    xs: "1 1 100%",
    sm: "1 1 calc(50% - 12px)",
    md: "1 1 120px",
  },
  minWidth: { xs: "100%", sm: 130, md: 110, lg: 130 },
  maxWidth: { xs: "100%", sm: "none", md: 220, lg: 240 },
};

export default function DatasheetList(props) {
  const [page, setPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const urlPath = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const theme = useTheme();
  const [datasheet, setDatasheet] = useState([]);
  const [finalData, setFinalData] = React.useState([]);
  // Tab state
  const [mainTab, setMainTab] = useState(() => sessionStorage.getItem("mainTab") || "all");
  const [subTab, setSubTab] = useState(() => sessionStorage.getItem("subTab") || "all");
  // Counts for every tab / sub-tab, fetched in a SINGLE query (see fetchCounts)
  const [counts, setCounts] = useState({
    allCount: 0,
    actionPendingCount: 0,
    approvedCount: 0,
    uncalibratedCount: 0,
    pendingApprovalCount: 0,
    sentForApprovalCount: 0,
  });

  const [selectedFilters, setSelectedFilters] = useState(sessionStorage.getItem("groupeSelectedFilters") || "");
  const [selectedLocation, setSelectedLocation] = useState(() => JSON.parse(sessionStorage.getItem("selectedLocation") || "[]"));
  const [filterDisciplines, setFilterDisciplines] = React.useState([]);
  const [usersArray, setUsersArray] = React.useState([]);
  const [allUsers, setUsers] = React.useState([]);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "DUC ID");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [from, setFrom] = useState(sessionStorage.getItem("dateFrom") || "");
  const [to, setTo] = useState(sessionStorage.getItem("dateTo") || "");
  const [searched, setSearched] = React.useState(false);
  const userType = localStorage.getItem("type");
  const editAccess = localStorage.getItem("editAccess")?.split(",").map(Number);
  const userId = localStorage.getItem("id");
  const branch = localStorage.getItem("branch");
  const _clientId = localStorage.getItem("clientId");
  const validCompanies = localStorage.getItem("validClients");

  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [dBStatus, setDBStatus] = React.useState("");
  const [settingList, setSettingList] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const [multipleJobAssign, setMultipleJobAssign] = useState(false);
  const [selectedSRFMultiple, setselectedSRfMultiple] = useState(null);
  const [selectedDisciplineIds, setSelectedDisciplineIds] = useState(() => JSON.parse(sessionStorage.getItem("selectedDisciplineIds") || "[]"));
  const [selectedCalStatus, setselectedCalStatus] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [jobAssignSelectedRows, setJobAssignSelectedRows] = useState([]);
  const [blockedJobIds, setBlockedJobIds] = useState([]);

  const [rowMenuAnchorEl, setRowMenuAnchorEl] = useState(null);
  const [rowMenuTarget, setRowMenuTarget] = useState(null);
  const [resetCounter, setResetCounter] = useState(0);

  const disciplineID = localStorage.getItem("disciplineID");
  const queryParams = new URLSearchParams(urlPath.search);
  const filter = queryParams.get("filter");

  const [isCalibrationTimeModalOpen, setIsCalibrationTimeModalOpen] = React.useState(false);
  const [calibrationTimeModalData, setCalibrationTimeModalData] = React.useState(null);
  const [isModalInfoOpen, setIsModalInfoOpen] = React.useState(false);
  const [infoModalData, setInfoModalData] = React.useState(null);

  const handleInfoOpenModal = React.useCallback((data) => {
    setInfoModalData(data);
    setIsModalInfoOpen(true);
  }, []);
  const handleInfoCloseModal = React.useCallback(() => {
    setIsModalInfoOpen(false);
    setInfoModalData(null);
  }, []);
  const handleCalibrationTimeOpenModal = React.useCallback((data) => {
    setCalibrationTimeModalData(data);
    setIsCalibrationTimeModalOpen(true);
  }, []);
  const handleCalibrationTimeCloseModal = React.useCallback(() => {
    setIsCalibrationTimeModalOpen(false);
    setCalibrationTimeModalData(null);
  }, []);

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const buildBaseConditions = useCallback(() => {
    const conditions = ["ds.status = 1"];
    // ADDED: safe checks, because localStorage can give null / "null" / "undefined" / ""
    const hasDiscipline = disciplineID && disciplineID !== "null" && disciplineID !== "undefined";
    const hasCompanies = validCompanies && validCompanies !== "null" && validCompanies !== "undefined";

    if (selectedLocation.length > 0) {
      conditions.push(`ds.location IN (${selectedLocation.join(",")})`);
    }

    if (searchBy !== "" && searchKey !== "") {
      const colName = {
        "Inst. Name": "ins.instrumentName",
        Client: "cust.companyName",
        "DUC ID": "ds.DUCID",
        "Certificate Number": "cert.certificateNumber",
        "SRF Number": "ds.serviceReqNumber",
        "Job Number": "ds.jobNumber",
        "DUC Location": "ds.locationOfInstrument",
        "ULR No": "cert.ULRNo",
        "Serial Number": "ds.serialNumber",
        Model: "ds.model",
      }[searchBy];
      if (colName) {
        conditions.push(`LOWER(${colName}) LIKE LOWER('%${searchKey}%')`);
      }
    }

    if (from && to) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      conditions.push(`ds.calibrationDate BETWEEN '${fromDate}' AND '${toDate}'`);
    }

    if (props.isCount == true) {
      conditions.push(`(ds.assignedUser = ${userId} AND ds.calibratedby IS NULL)`);
    }

    if (userType == 2) {
      if (filter === "self") conditions.push(`ds.createdby = ${userId}`);
      else if (filter === "assigned") conditions.push(`ds.assignedUser = ${userId}`);
      else if (filter === "pending")
        conditions.push(`(ds.totalReadings IS NULL OR ds.totalReadings = 0) AND (ds.createdby = ${userId} OR ds.assignedUser = ${userId})`);
      else if (filter === "completed")
        conditions.push(`(ds.totalReadings IS NOT NULL AND ds.totalReadings > 0) AND (ds.createdby = ${userId} OR ds.assignedUser = ${userId})`);
    }

    if ((userType == "2" || userType == "8") && hasDiscipline) {
      conditions.push(`disc.id IN (${disciplineID})`);
    }

    if (settingList["hideSRF"]?.toLowerCase() === "true") {
      conditions.push(`(ds.hideSrfUserIds IS NULL OR FIND_IN_SET(${userId}, ds.hideSrfUserIds) = 0)`);
    }

    if ((userType == "2" || userType == "8") && !hasDiscipline) { 
      let clause = `(ds.assignedUser = ${userId} OR ds.createdby = ${userId}`;
      if (userType == "8" && hasCompanies) {
        clause += ` OR cust.id IN (${validCompanies}))`;
      } else {
        clause += `)`;
      }
      conditions.push(clause);
    }

    if (Array.isArray(selectedDisciplineIds) && selectedDisciplineIds.length > 0) {
      conditions.push(`disc.id IN (${selectedDisciplineIds.join(",")})`);
    }

    if (selectedCalStatus === "CALIBRATED") {
      conditions.push(`ds.totalReadings IS NOT NULL AND ds.totalReadings > 0 AND ds.calibratedBy IS NOT NULL`);
    } else if (selectedCalStatus === "NON_CALIBRATED") {
      conditions.push(`(ds.totalReadings IS NULL OR ds.totalReadings = 0 OR ds.calibratedBy IS NULL)`);
    }

    if (userType == "3") {
      conditions.push(`ds.clientId = ${_clientId} AND ds.datasheetApprovedBy IS NOT NULL AND ds.datasheetApprovedBy != ''`);
    }

    if ((userType == 4 || userType == 5) && branch && branch !== "null" && branch.length) {
      conditions.push(`cust.branch IN (${branch})`);
    }

    // tab/sub-tab the user has selected (see STATUS_FILTER_OPTIONS)
    // Status filter (only selectable on the "All Datasheets" tab)
    if (selectedFilters) {
      if (selectedFilters === "Uncalibrated") {
        conditions.push(`(ds.totalReadings IS NULL OR ds.totalReadings = 0)`);
      } else if (selectedFilters === "Calibrated") {
        conditions.push(`(ds.totalReadings IS NOT NULL AND ds.totalReadings > 0)`);
      } else if (selectedFilters === "Approved") {
        conditions.push(`ds.datasheetApprovedBy IS NOT NULL`);
      }
    }

    return conditions;
  }, [ selectedLocation, searchBy, searchKey, from, to, props.isCount, props.rolesInfo, userType, filter, disciplineID, settingList, validCompanies, selectedDisciplineIds, selectedCalStatus, userId, branch, _clientId, selectedFilters]); 

  // Tab-specific condition, appended on top of buildBaseConditions() for the
  const tabCondition = useMemo(() => {
    if (mainTab === "approved") return "ds.datasheetApprovedBy IS NOT NULL";
    if (mainTab === "pending") {
      switch (subTab) {
        case "uncalibrated":
          return `(ds.totalReadings IS NULL OR ds.totalReadings = 0)`;
        case "pendingApproval":
          return `ds.totalReadings IS NOT NULL AND ds.totalReadings > 0 AND (cert.status IS NULL OR cert.status <> ${CERT_STATUS_SENT_FOR_APPROVAL})`;
        case "sentForApproval":
          return `cert.status = ${CERT_STATUS_SENT_FOR_APPROVAL} AND cert.approvedBy IS NULL`;
        default:
          return "";
      }
    }
    return null; // "all" tab - no extra condition
  }, [mainTab, subTab]);

  const FROM_JOIN = `datasheets AS ds
    LEFT JOIN instruments AS ins ON ds.instrumentId = ins.id
    LEFT JOIN clients AS cust ON ds.clientId = cust.id
    LEFT JOIN discipline AS disc ON disc.id = ins.disciplineId
    LEFT JOIN certificates AS cert ON ds.id = cert.id`;

  const buildRowsQuery = useCallback(() => {
    const conditions = buildBaseConditions();
    if (tabCondition) conditions.push(tabCondition);
    const where = conditions.length ? `WHERE ${conditions.join(" AND ")}` : "";
    const pagination = rowsPerPage != -1 ? `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(page)}` : "";

    const query = `SELECT disc.id AS discID, cert.status AS certStatus, cert.certificateNumber AS certCertificateNumber, ds.calibrationCoordinates, ds.complianceStatus, ds.model, cert.ULRNo AS ULRNo, ds.datasheetApprovedBy, ds.totalReadings, ds.calibrationType, ds.mpe, ds.locationOfInstrument, ds.createdby, ds.calFrequency, ds.lastModified, ds.calibratedBy, cust.companyName, cust.uniCode, ins.instrumentName, ds.requestedname, ins.id AS insId, ds.id, ds.workOrderNumber, ds.certificateNumber, ds.calibrationDate, ds.calProcRefNo, ds.ranges, ds.lc, ds.calibrationStartTime, ds.calibrationEndTime, ds.DUCID, ds.identificationNo, ds.jobNumber, ds.nextDueDate, ds.dateOfIssue, ds.assignedUser, ds.serialNumber, ds.serviceReqNumber, ${CALIBRATION_STATUS_CASE} AS calibrationStatus, ${APPROVAL_STATUS_CASE} AS approvalStatus FROM ${FROM_JOIN} ${where} ORDER BY ds.id DESC ${pagination}`;

    return { query: query.replace(/\s+/g, " ").trim() };
  }, [buildBaseConditions, tabCondition, rowsPerPage, page]);

  // COUNT() calls (one per tab badge). The count for whichever tab/sub-tab
  // is currently active is also reused directly as the pagination total, so
  const buildCountsQuery = useCallback(() => {
    const conditions = buildBaseConditions();
    const where = conditions.length ? `WHERE ${conditions.join(" AND ")}` : "";

    const query = `SELECT
        COUNT(*) AS allCount,
        SUM(CASE WHEN ds.datasheetApprovedBy IS NULL THEN 1 ELSE 0 END) AS actionPendingCount,
        SUM(CASE WHEN ds.datasheetApprovedBy IS NOT NULL THEN 1 ELSE 0 END) AS approvedCount,
        SUM(CASE WHEN ds.datasheetApprovedBy IS NULL AND (ds.totalReadings IS NULL OR ds.totalReadings = 0) THEN 1 ELSE 0 END) AS uncalibratedCount,
        SUM(CASE WHEN ds.datasheetApprovedBy IS NULL AND ds.totalReadings IS NOT NULL AND ds.totalReadings > 0 THEN 1 ELSE 0 END) AS pendingApprovalCount,
        SUM(CASE WHEN cert.status = ${CERT_STATUS_SENT_FOR_APPROVAL} AND cert.approvedBy IS NULL THEN 1 ELSE 0 END) AS sentForApprovalCount
      FROM ${FROM_JOIN}
      ${where}`;

    return { query: query.replace(/\s+/g, " ").trim() };
  }, [buildBaseConditions]);

  const totalRowsForActiveTab = useMemo(() => {
    if (mainTab === "approved") return counts.approvedCount || 0;
    if (mainTab === "pending") {
      switch (subTab) {
        case "uncalibrated":
          return counts.uncalibratedCount || 0;
        case "pendingApproval":
          return counts.pendingApprovalCount || 0;
        case "sentForApproval":
          return counts.sentForApprovalCount || 0;
        default:
          return counts.actionPendingCount || 0;
      }
    }
    return counts.allCount || 0;
  }, [mainTab, subTab, counts]);

  const fetchCounts = useCallback(() => {
    return axiosWithToken
      .post(BASE_URL + `dynamic`, buildCountsQuery())
      .then((res) => {
        const row = res.data?.[0] || {};
        setCounts({
          allCount: Number(row.allCount || 0),
          actionPendingCount: Number(row.actionPendingCount || 0),
          approvedCount: Number(row.approvedCount || 0),
          uncalibratedCount: Number(row.uncalibratedCount || 0),
          pendingApprovalCount: Number(row.pendingApprovalCount || 0),
          sentForApprovalCount: Number(row.sentForApprovalCount || 0),
        });
      })
      .catch((err) => console.error("counts fetching error: ", err));
  }, [buildCountsQuery]);

  const fetchDatasheet = useCallback(() => {
    return axiosWithToken
      .post(BASE_URL + `dynamic`, buildRowsQuery())
      .then((res) => {
        setDatasheet([...res.data]);
        setFinalData([...res.data]);
      })
      .catch((err) => console.error("datasheet data fetching error: ", err));
  }, [buildRowsQuery]);

  // Single entry point that loads counts + rows together (parallel, not
  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      await Promise.all([fetchCounts(), fetchDatasheet()]);
    } finally {
      setLoading(false);
    }
  }, [fetchCounts, fetchDatasheet]);

  const saveUserAndDsID = async (userIdToAssign) => {
    if (!jobAssignSelectedRows.length) return;
    const assignedUserValue = userIdToAssign === 0 ? null : userIdToAssign;
    try {
      await axiosWithToken.post(`${BASE_URL}dynamic`, {
        query: `UPDATE datasheets SET assignedUser = ${assignedUserValue}, jobAssignedDate = NOW() WHERE id IN (${jobAssignSelectedRows.join(",")});`,
      });
      toast("Datasheets Assigned.");
      setJobAssignSelectedRows([]);
      loadData();
    } catch (err) {
      console.error("Error updating datasheets:", err);
    }
  };

  const getUserList = () => {
    axiosWithToken
      .get(BASE_URL + "users")
      .then((res) => setUsersArray(res.data))
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const pushCArray = [];
    for (let i = 0; i < usersArray.length; i++) {
      if (usersArray[i].type == 2 || usersArray[i].type == 8) {
        pushCArray.push({ label: usersArray[i].id + ", " + usersArray[i].userName });
      }
    }
    setUsers(pushCArray);
  }, [usersArray]);

  function fetchSettings() {
    axiosWithToken
      .get(BASE_URL + `settings?_where=(status,eq,1)`)
      .then((res) => {
        const _settingList = {};
        res.data.forEach((setting) => {
          _settingList[setting.keyName] = setting.value;
        });
        setSettingList(_settingList);
      })
      .catch((err) => console.error("Error fetching setting:", err));
  }

  function getassignJob(callback) {
    if (userType != 2) return;
    const query = `SELECT id, assignedUser, jobAssignedDate, totalReadings, calibratedBy, DUCID, jobNumber, TIMESTAMPDIFF(HOUR, jobAssignedDate, NOW()) AS hoursElapsed FROM datasheets WHERE assignedUser = ${userId} AND status = 1 AND jobAssignedDate >= DATE_SUB(NOW(), INTERVAL 4 DAY)`;

    axiosWithToken
      .post(`${BASE_URL}dynamic`, { query })
      .then((res) => {
        const allJobs = res.data;
        const overduePendingJobs = allJobs.filter(
          (job) => (job.totalReadings === null || job.totalReadings == 0) && job.calibratedBy === null && job.hoursElapsed > 48,
        );
        const newPendingJobs = allJobs.filter(
          (job) => (job.totalReadings === null || job.totalReadings == 0) && job.calibratedBy === null && job.hoursElapsed <= 48,
        );
        const blockedIds = overduePendingJobs.length > 0 ? newPendingJobs.map((job) => job.id) : [];

        if (overduePendingJobs.length > 0) {
          toast.warning(
            <div>
              <b>⚠️ {overduePendingJobs.length} Overdue Job(s) pending more than 48 hours!</b>
              <br />
              <small>Complete them first before opening new jobs:</small>
              <br />
              <br />
              {overduePendingJobs.map((job, i) => (
                <div key={i} style={{ marginBottom: "4px", padding: "4px", background: "#fff3cd", borderRadius: "4px" }}>
                  <b>Job No:</b> {job.jobNumber || "N/A"} &nbsp;|&nbsp;
                  <b>DUC ID:</b> {job.DUCID || "N/A"}
                </div>
              ))}
            </div>,
            { autoClose: 4000 },
          );
        }
        if (callback) callback({ blockedJobIds: blockedIds, overduePendingJobs, newPendingJobs });
      })
      .catch((err) => console.error("Error fetching assigned jobs:", err));
  }

  function fetchDisciplinesForSRF() {
    axiosWithToken
      .post(BASE_URL + `dynamic`, {
        query: `SELECT id, name FROM discipline ORDER BY id;`,
      })
      .then((res) => setFilterDisciplines(res.data))
      .catch(() => setFilterDisciplines([]));
  }

  // One-time setup
  useEffect(() => {
    getUserList();
    checkDSStatusByCount(setDBStatus);
    fetchSettings();
    fetchDisciplinesForSRF();
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("searched")) setSearched(true);
  }, []);

  useEffect(() => {
    if (settingList["JobRestrinctionEng"] == "true") {
      getassignJob(({ blockedJobIds }) => setBlockedJobIds(blockedJobIds));
    }
  }, [settingList["JobRestrinctionEng"]]);

  // Single data-loading effect. Anything that should trigger a refetch of
  useEffect(() => {
    loadData();
  }, [page, rowsPerPage, mainTab, subTab, disciplineID, settingList["hideSRF"], selectedCalStatus]);

  useEffect(() => {
    if (resetCounter > 0) {
      loadData();
    }
  }, [resetCounter]);

  useEffect(() => {
    if (selectedSRFMultiple) {
      setSearchBy("SRF Number");
      setSearchKey(selectedSRFMultiple);
      setPage(0);
      loadData();
    }
  }, [selectedSRFMultiple]);

  const resetSearchState = () => {
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("dateFrom");
    sessionStorage.removeItem("dateTo");
    sessionStorage.removeItem("selectedLocation");
    sessionStorage.removeItem("groupeSelectedFilters");
    sessionStorage.removeItem("selectedDisciplineIds");
    sessionStorage.removeItem("searched");
    setSearchKey("");
    setFrom("");
    setTo("");
    setSelectedLocation([]);
    setSelectedDisciplineIds([]);
    setSelectedFilters("");
    setSearched(false);
  };

  const handleMainTabChange = (event, newTab) => {
    setMainTab(newTab);
    setSubTab("all");
    setPage(0);
    resetSearchState();
    sessionStorage.setItem("mainTab", newTab);
    sessionStorage.setItem("subTab", "all");
  };

  const handleSubTabChange = (newSubTab) => {
    setSubTab(newSubTab);
    setPage(0);
    resetSearchState();
    sessionStorage.setItem("subTab", newSubTab);
  };

  // a search when idle, and clears it once a search is active.
  const search = () => {
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    sessionStorage.setItem("groupeSelectedFilters", selectedFilters);
    sessionStorage.setItem("selectedDisciplineIds", JSON.stringify(selectedDisciplineIds));
    sessionStorage.setItem("selectedLocation", JSON.stringify(selectedLocation));
    if (from) sessionStorage.setItem("dateFrom", from);
    if (to) sessionStorage.setItem("dateTo", to);
    setPage(0);
    setSearched(true);
    loadData();
    handleFilterClose();
  };

  // tab, with the filters cleared.
  const clearSearch = () => {
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    sessionStorage.removeItem("currentPath");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("groupeSelectedFilters");
    sessionStorage.removeItem("selectedLocation");
    sessionStorage.removeItem("selectedDisciplineIds");
    sessionStorage.removeItem("dateFrom");
    sessionStorage.removeItem("dateTo");
    setPage(0);
    setSearchBy("DUC ID");
    setSelectedFilters("");
    setSearchKey("");
    setFrom("");
    setTo("");
    setSelectedDisciplineIds([]);
    setselectedCalStatus("");
    setselectedSRfMultiple(null);
    setSelectedLocation([]);
    setSearched(false);
    // Trigger exactly one reload, once the above state has committed and
    setResetCounter((c) => c + 1);
  };

  const handleSelectAllClick = () => {
    const eligibleIds = datasheet?.filter((row) => row.calibratedBy !== null).map((row) => row.id) || [];
    const allSelected = selectedRows.length === eligibleIds.length && eligibleIds.length > 0;
    setSelectedRows(allSelected ? [] : eligibleIds);
  };

  const handleRowClick = (event, id) => {
    setSelectedRows((prev) => (prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]));
  };

  const handleJobAssignSelectAll = () => {
    setJobAssignSelectedRows(jobAssignSelectedRows.length === datasheet.length ? [] : datasheet.map((row) => row.id));
  };

  const handleJobAssignRowClick = (id) => {
    setJobAssignSelectedRows((prev) => (prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]));
  };

  const handleApproveClick = async () => {
    const selectedCertificates = datasheet?.filter((ds) => selectedRows.includes(ds.id)) || [];
    const noncomplianceStatusCerts = selectedCertificates?.filter((ds) => ds.complianceStatus != 1);
    const complianceStatusCerts = selectedCertificates?.filter((ds) => ds.complianceStatus == 1)?.map((ds) => ds.id) || [];
    const message =
      noncomplianceStatusCerts.length > 0
        ? `Compliance Status is failed for the following:\n${noncomplianceStatusCerts
            .map((ds) => `Instrument Name: ${ds.instrumentName}, DUCID: ${ds.DUCID}, Job NO: ${ds.jobNumber}`)
            .join("\n")}`
        : "";

    const allDatasheetToApprove = [...(noncomplianceStatusCerts?.map((ds) => ds.id) || []), ...complianceStatusCerts];

    if (settingList["Compliance Status Alert"]?.toLowerCase() === "true" && noncomplianceStatusCerts.length > 0) {
      window.alert(message);
    }

    if (editAccess?.includes(7) && allDatasheetToApprove.length > 0) {
      await datasheetsApprove(allDatasheetToApprove);
    } else if (complianceStatusCerts?.length > 0) {
      await datasheetsApprove(complianceStatusCerts);
    }
    setSelectedRows([]);
    loadData();
  };


  let showCheckboxForApprove = props.rolesInfo?.currentRole?.id == 2 && userType !== "3" && !isMobile && disciplineID != "null";
  let showCheckboxForJobAsiign = userType == 1 || userType == 4 || userType == 5 || userType == 8 || props.rolesInfo?.currentRole?.id == 2;

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onPageChange } = props;
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0} aria-label="first page">
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0} aria-label="previous page">
          {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
          {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  const mainTabsBlock = (
    <Tabs
      value={mainTab}
      onChange={handleMainTabChange}
      sx={{ borderBottom: 1, borderColor: "divider", mb: 1.5, minHeight: 28 }}
      TabIndicatorProps={{ style: { height: 3 } }}
    >
      {MAIN_TABS
        .filter((t) => userType === "3" ? t.key === "all" : true)
        .map((t) => (
        <Tab
          key={t.key}
          value={t.key}
          sx={{ minHeight: 32, padding: "4px 12px", fontSize: "0.8rem" }}
          label={
            <span style={{ fontWeight: "bold" }}>
              {t.label}{" "}
              <b>({t.key === "all" ? counts.allCount : t.key === "pending" ? counts.actionPendingCount : counts.approvedCount})</b>
            </span>
          }
        />
      ))}
    </Tabs>
  );

  const subTabCountFor = (key) => {
    switch (key) {
      case "all":
        return counts.actionPendingCount;
      case "uncalibrated":
        return counts.uncalibratedCount;
      case "pendingApproval":
        return counts.pendingApprovalCount;
      case "sentForApproval":
        return counts.sentForApprovalCount;
      default:
        return 0;
    }
  };

  const subTabsBlock = mainTab === "pending" && (
    <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
      {SUB_TABS.map((t) => (
        <Chip
          key={t.key}
          label={`${t.label} (${subTabCountFor(t.key)})`}
          clickable
          color={subTab === t.key ? "primary" : "default"}
          variant={subTab === t.key ? "filled" : "outlined"}
          onClick={() => handleSubTabChange(t.key)}
        />
      ))}
    </Stack>
  );

  const filterSection = () => (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "flex-end", mb: 1 }}>
      {mainTab === "all" && (
        <>
        <Box sx={{...toolbarFieldSx, flex: "0 1 110px", minWidth: { xs: "100%", sm: 110 }, maxWidth: { xs: "100%", sm: 130 } }}>
          <TextField
            id="datasheet_date_from"
            label="From Date"
            variant="outlined"
            type="date"
            className="Listinputcss"
            style={{ width: "100%" }}
            InputLabelProps={{ shrink: true }}
            size="small"
            value={from}
            onChange={(e) => {
              setFrom(e.target.value);
              setSearched(false);
            }}
          />
        </Box>
        <Box sx={{...toolbarFieldSx, flex: "0 1 110px", minWidth: { xs: "100%", sm: 110 }, maxWidth: { xs: "100%", sm: 130 } }}>
          <TextField
            id="datasheet_date_to"
            label="To Date"
            variant="outlined"
            type="date"
            className="Listinputcss"
            style={{ width: "100%" }}
            InputLabelProps={{ shrink: true }}
            size="small"
            value={to}
            onChange={(e) => {
              setTo(e.target.value);
              setSearched(false);
            }}
          />
        </Box>
        </>
      )}
      <Box sx={toolbarFieldSx}>
        <Autocomplete
          sx={{ width: "100%" }}
          size="small"
           ListboxProps={{
            sx: {
              "& .MuiAutocomplete-option": {
                fontSize: "14px !important",
                minHeight: "30px !important",
                padding: "3px 8px !important",
              },
            },
          }}
          className="Listinputcss"
          value={searchBy}
          id="datasheet_list_searchby"
          options={["Client", "Inst. Name", "DUC ID", "Serial Number", "Certificate Number", "SRF Number", "Model", "Job Number", "DUC Location", "ULR No"]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            if (newInputValue === "") setSearchKey("");
            setSearchBy(newInputValue);
            setSearched(false);
          }}
        />
      </Box>
      <Box sx={toolbarFieldSx} id="datasheet_list_searchbytext">
        <TextField
          style={{ width: "100%" }}
          label={"Enter " + searchBy}
          size="small"
          variant="outlined"
          className="Listinputcss"
          inputProps={{ autoComplete: "off" }}
          value={searchKey}
          onChange={(e) => {
            setSearchKey(e.target.value);
            setSearched(false);
          }}
        />
      </Box>
      <Box sx={{...toolbarFieldSx, flex: "0 1 110px", minWidth: { xs: "100%", sm: 120 }, maxWidth: { xs: "100%", sm: 140 } }}>
        <Autocomplete
          sx={{ width: "100%" }}
          className="Listinputcss"
          multiple
          limitTags={1}
          ListboxProps={{
            sx: {
              "& .MuiAutocomplete-option": {
                fontSize: "14px !important",
                minHeight: "30px !important",
                padding: "3px 8px !important",
              },
            },
          }}
          disableCloseOnSelect
          size="small"
          value={locationOptions.filter((option) => selectedLocation.includes(option.id))}
          id="datasheet_list_locationfilter"
          options={locationOptions}
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.id == value.id}
          renderInput={(params) => <TextField {...params} label="Calibration Location" />}
          onChange={(event, newValue) => {
            setSelectedLocation(newValue.map((option) => option.id));
            setSearched(false);
          }}
        />
      </Box>
      {mainTab === "all" && (
        <Box sx={toolbarFieldSx}>
          <Autocomplete
            sx={{ width: "100%" }}
            size="small"
            className="Listinputcss"
             ListboxProps={{
              sx: {
                "& .MuiAutocomplete-option": {
                  fontSize: "14px !important",
                  minHeight: "30px !important",
                  padding: "3px 8px !important",
                },
              },
            }}
            id="datasheet_list_statusfilter"
            options={STATUS_FILTER_OPTIONS}
            value={selectedFilters || null}
            renderInput={(params) => <TextField {...params} label="Filter by Status" />}
            onChange={(event, newValue) => {
              setSelectedFilters(newValue || "");
              setSearched(false);
            }}
          />
        </Box>
      )}
      {userType != 3 && (
        <Box sx={toolbarFieldSx}>
          <Autocomplete
            sx={{ m: 0, width: "100%", }}
            className="Listinputcss"
            size="small"
            multiple
            limitTags={1}
            disableCloseOnSelect
            ListboxProps={{
              sx: {
                "& .MuiAutocomplete-option": {
                  fontSize: "14px !important",
                  minHeight: "30px !important",
                  padding: "3px 8px !important",
                },
              },
            }}
            options={filterDisciplines.map((d) => ({ label: `${d.id}, ${d.name}`, value: d.id }))}
            value={filterDisciplines
              .filter((d) => selectedDisciplineIds.includes(d.id))
              .map((d) => ({ label: `${d.id}, ${d.name}`, value: d.id }))}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(event, newValue) => {
              setSelectedDisciplineIds(newValue.map((o) => o.value));
              setSearched(false);
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox checked={selected} size="small" sx={{ mr: 1, p: 0.5 }} />
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Discipline" />
            )}
          />
        </Box>
      )}
      <Box sx={{ display: "flex", alignItems: "flex-end" }} id="datasheet_list_searchbtn">
        <Button
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          sx={{ height: 31, minWidth: 45, px: 1 }}
          onClick={() => (searched ? clearSearch() : search())}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Box>
    </Box>
  );

  const filterModal = () => (
    <Modal open={filterModalOpen} size="md">
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 30%)",
          backgroundColor: "white",
          boxShadow: 24,
          padding: "10px",
        }}
      >
        <Button variant="contained" size="small" color="error" sx={{ float: "right", minWidth: 20, width: 20, height: 20, padding: 0, fontSize: 10 }} onClick={handleFilterClose}>
          X
        </Button>
        {filterSection()}
      </Box>
    </Modal>
  );
  
  const jobAssignRowBlock = jobAssignSelectedRows.length > 0 && (
    <Grid item xs={12} md={3}>
      <Autocomplete
        sx={{ width: 250 }}
        size="small"
        className="Listinputcss"
        id="combo-box-demos"
        options={[{ label: "0, Withdraw Job" }, ...allUsers]}
        getOptionLabel={(option) => option.label}
        renderOption={(props, option) => (
          <li {...props} style={{ color: option.label.startsWith("0, Withdraw Job") ? "red" : "inherit" }}>
            {option.label}
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="Job Assign" />}
        onInputChange={(event, newInputValue) => saveUserAndDsID(parseInt(newInputValue.split(",")[0]))}
      />
    </Grid>
  );

  const actionBarBlock = (
    <Box sx={{ display: "flex", pt: 0.5, borderTop: "1px solid", borderColor: "divider", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 1.5, mb: 1 }}>
      <Stack direction="row" spacing={1.5} flexWrap="wrap">
        {showCheckboxForJobAsiign && !isMobile && (
          <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={() => setMultipleJobAssign(!multipleJobAssign)}>
            Assign Job
          </Button>
        )}
        {selectedRows.length > 0 && props.rolesInfo?.currentRole?.id == 2 && (
          <Button variant="contained" color="success" size="small" startIcon={<CheckCircleIcon />} onClick={handleApproveClick}>
            Approve
          </Button>
        )}
        {selectedRows.length > 0 && (
          <Button variant="contained" size="small"  onClick={() => datashettAprroveWithdrawl(selectedRows)}>
            Withdraw Approval
          </Button>
        )}
         {jobAssignRowBlock}
      </Stack>
    </Box>
  );

  const StatusChip = ({ status }) => {
    if (!status) return null;
    const style = STATUS_CHIP_STYLES[status] || { color: "default" };
    return <Chip size="small" label={status} color={style.color} />;
  };

  const openRowMenu = (event, row) => {
    setRowMenuAnchorEl(event.currentTarget);
    setRowMenuTarget(row);
  };
  const closeRowMenu = () => {
    setRowMenuAnchorEl(null);
    setRowMenuTarget(null);
  };

  return (
    <ListWrap>
      {dBStatus === "sick" ? (
        <h1 style={{ color: "red" }}>
          Record count is mismatching. <br /> please contact the support team. Tel: +91 9769847865
        </h1>
      ) : null}
      {dBStatus !== "sick" && (
        <>
          {filterModal()}
          {mainTabsBlock}
          {subTabsBlock}
          {isMobile && (
          <div style={{ display: "flex", justifyContent: "flex-start" }}>
            <Button style={{ display: isMobile ? "block" : "none" }} onClick={handleFilterOpen}>
              <FilterAltIcon />
            </Button>
          </div>
          )}
          {!isMobile && filterSection()}
          {actionBarBlock}
          {multipleJobAssign && (
            <MultipleJobAssignButton
              multipleJobAssign={multipleJobAssign}
              setMultipleJobAssign={setMultipleJobAssign}
              allUsers={allUsers}
              setselectedSRfMultiple={setselectedSRfMultiple}
              setSearched={setSearched}
              clearSearch={clearSearch}
              setSelectedDisciplineIds={setSelectedDisciplineIds}
              setselectedCalStatus={setselectedCalStatus}
              selectedCalStatus={selectedCalStatus}
            />
          )}

          <Box sx={{ width: "100%", overflow: "hidden", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
            <TableContainer sx={{ flex: 1, overflow: "auto" }}>
              <Table stickyHeader aria-label="sticky table" className="table-responsive" size="small" id="datasheet_list_table" sx={{
                  borderCollapse: "collapse",
                  "& .MuiTableCell-root": {
                    padding: "6px 10px",
                    fontSize: "0.75rem",
                    lineHeight: 1.35,
                  },
                  "& .MuiTableCell-head": {
                    fontSize: "0.75rem",
                    fontWeight: 700,
                  },
                  "& .MuiChip-root": {
                    height: 22,
                    fontSize: "0.7rem",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    {showCheckboxForApprove && (
                      <TableCell style={{ padding: "5px", textAlign: "center", fontWeight: "bold", whiteSpace: "nowrap" }}>
                        <b>Approve</b><br/>
                        <Checkbox
                          indeterminate={selectedRows.length > 0 && selectedRows.length < datasheet.length}
                          checked={selectedRows.length === datasheet.length && datasheet.length > 0}
                          onChange={handleSelectAllClick}
                        />
                      </TableCell>
                    )}
                    {showCheckboxForJobAsiign && (
                      <TableCell style={{ padding: "5px", whiteSpace: "nowrap", textAlign: "center", fontWeight: "bold" }}>
                      <b>Job Assign</b><br/>
                        <Checkbox
                          indeterminate={jobAssignSelectedRows.length > 0 && jobAssignSelectedRows.length < datasheet.length}
                          checked={jobAssignSelectedRows.length === datasheet.length && datasheet.length > 0}
                          onChange={handleJobAssignSelectAll}
                        />
                      </TableCell>
                    )}
                    <TableCell align="center" style={{ minWidth: 40, whiteSpace: "nowrap" }}><b>Sr.No.</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 130, whiteSpace: "nowrap" }}><b>Client</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 140, whiteSpace: "nowrap" }}><b>Calibration Status</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 140, whiteSpace: "nowrap" }}><b> Datasheet Approval Status</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 180, whiteSpace: "nowrap" }}><b>Service Request Number</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 120, whiteSpace: "nowrap" }}><b>Job Number</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 150, whiteSpace: "nowrap" }}><b>Certificate Number</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 100, whiteSpace: "nowrap" }}><b>ULR No</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 150, whiteSpace: "nowrap" }}><b>Instrument Name</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 120, whiteSpace: "nowrap" }}><b>DUC Location</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 100, whiteSpace: "nowrap" }}><b>Range</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 80, whiteSpace: "nowrap" }}><b>LC</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 100, whiteSpace: "nowrap" }}><b>DUC ID</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 120, whiteSpace: "nowrap" }}><b>Serial Number</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 100, whiteSpace: "nowrap" }}><b>Model</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 140, whiteSpace: "nowrap" }}><b>Date of Calibration</b></TableCell>
                    <TableCell align="center" style={{ minWidth: 110, whiteSpace: "nowrap" }}><b>Due Date</b></TableCell>
                    {userType != "3" && <TableCell align="center" style={{ minWidth: 120, whiteSpace: "nowrap" }}><b>Assign To</b></TableCell>}
                    <TableCell align="center" style={{ minWidth: 110, whiteSpace: "nowrap" }}><b>Calibratd By</b></TableCell>
                    <TableCell align="center" sx={{ minWidth: 100, whiteSpace: "nowrap" }}><b>Actions</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={userType != "3" ? 19 : 18} align="center"><h6><b>Loading…</b></h6></TableCell>
                    </TableRow>
                  ) : finalData?.length > 0 ? (
                    finalData.map((row, index) => {
                      const isRowBlocked = blockedJobIds.includes(row.id);
                      const approvedTitle =
                        row.datasheetApprovedBy != null
                          ? `Approved by ${usersArray?.find((user) => user.id == row.datasheetApprovedBy)?.userName || ""}`
                          : row?.totalReadings != 0
                            ? `Calibrated by ${usersArray?.find((user) => user.id == row.calibratedBy)?.userName || ""}`
                            : "";
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                          {showCheckboxForApprove && (
                            <TableCell sx={{ padding: "5px", textAlign: "center" }}>
                              <FormControlLabel
                                sx={{ gap: 2, margin: 0 }}
                                control={
                                  <Checkbox
                                    id="certificate-certificatelistselectcheckbox"
                                    checked={selectedRows.indexOf(row.id) !== -1}
                                    onChange={(event) => handleRowClick(event, row.id)}
                                  />
                                }
                                disabled={row.calibratedBy == null}
                              />
                            </TableCell>
                          )}
                          {showCheckboxForJobAsiign && (
                            <TableCell align="center" sx={{ padding: "5px", textAlign: "center" }}>
                              <Checkbox checked={jobAssignSelectedRows.includes(row.id)} onChange={() => handleJobAssignRowClick(row.id)} />
                            </TableCell>
                          )}
                          <TableCell align="center" sx={{ padding: "5px", textAlign: "center" }}>{rowsPerPage * Number(page) + index + 1}</TableCell>
                          <TableCell align="center" title={row.calibrationType == 1 ? "NABL" : row.calibrationType == 2 ? "IAS" : "NONANBL"}>
                            {row.companyName} <b>{row.uniCode ? `(${row.uniCode})` : ""}</b>
                          </TableCell>
                          <TableCell align="center"><StatusChip status={row.calibrationStatus} /></TableCell>
                          <TableCell align="center" title={approvedTitle}><StatusChip status={row.approvalStatus} /></TableCell>
                          <TableCell
                            // style={{ backgroundColor: row.datasheetApprovedBy != null ? "#7B7BDF" : row?.totalReadings && row?.totalReadings != 0 ? "#22c9b0" : "transparent" }}
                            // title={approvedTitle}
                          >
                            <Link
                              to={`/datasheet/edit/${row.id}/${row.insId}`}
                              className="custom-link"
                              title="Edit Datasheet"
                              style={{ pointerEvents: userType == 3 || isRowBlocked ? "none" : "auto" }}
                              disabled={isRowBlocked}
                            >{row.serviceReqNumber}</Link>
                          </TableCell>
                          <TableCell
                            // style={{
                            //   backgroundColor:
                            //     row.datasheetApprovedBy != null ? "#7B7BDF" : row?.totalReadings && row?.totalReadings != 0 ? "#22c9b0" : "transparent",
                            // }}
                            // title={approvedTitle}
                          >
                            <Link
                              to={`/datasheet/edit/${row.id}/${row.insId}`}
                              className="custom-link"
                              title="Edit Datasheet"
                              style={{ pointerEvents: userType == 3 || isRowBlocked ? "none" : "auto" }}
                            >{row.jobNumber}</Link>
                          </TableCell>
                          <TableCell align="center">{row.certCertificateNumber}</TableCell>
                          <TableCell align="center">{row.ULRNo}</TableCell>
                          <TableCell align="center">{row.instrumentName}</TableCell>
                          <TableCell align="center">{row?.locationOfInstrument}</TableCell>
                          <TableCell align="center">{parseRange(row.ranges)}</TableCell>
                          <TableCell align="center">{parseRange(row.lc)}</TableCell>
                          <TableCell align="center">{row.DUCID}</TableCell>
                          <TableCell align="center">{row.serialNumber}</TableCell>
                          <TableCell align="center">{row?.model}</TableCell>
                          <TableCell align="center" style={{ textWrap: "nowrap" }}>{DateisValid(row.calibrationDate,"DD-MM-YYYY")}</TableCell>
                          <TableCell align="center" style={{ textWrap: "nowrap" }}>
                            {row?.calFrequency == "Not Required"
                              ? "-"
                              : row?.calFrequency == "Customer Defined"
                                ? "Customer Defined"
                                : row?.calFrequency == "NA"
                                  ? "NA"
                                  : DateisValid(row?.nextDueDate,"DD-MM-YYYY")}
                          </TableCell>
                          {userType != "3" && (
                            <TableCell>
                              {row.assignedUser !== null
                                ? allUsers
                                    ?.find((user) => parseInt(user.label?.split(",")[0]?.trim()) === row.assignedUser)
                                    ?.label?.split(",")[1]
                                    ?.trim() || ""
                                : ""}
                            </TableCell>
                          )}
                           <TableCell>
                            {usersArray?.find((user) => user.id == row.calibratedBy)?.userName || ""}
                            </TableCell>                          
                          <TableCell>
                            <Stack direction="row" spacing={0.5} alignItems="center">
                              {userType !== "3" && (
                                <Tooltip title={isRowBlocked ? "The datasheet is blocked. Kindly complete the old job first." : "View / Edit Datasheet"}>
                                  <span>
                                    <IconButton
                                      id="datasheet_list_editbutton"
                                      component={Link}
                                      to={`/datasheet/edit/${row.id}/${row.insId}`}
                                      size="small"
                                      disabled={isRowBlocked}
                                      sx={{ color: "primary.main" }}
                                    >
                                      <PreviewIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )}
                              {userType !== "3" && (
                                <Tooltip title="Send for Approval">
                                  <IconButton
                                    disabled={row.certStatus == CERT_STATUS_SENT_FOR_APPROVAL}
                                    onClick={() => certificateStatusUpdate(row.id, row)}
                                    sx={{ color: "primary.main" }}
                                    size="small"
                                  >
                                    <SendIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                              <IconButton onClick={(e) => openRowMenu(e, row)}>
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={userType != "3" ? 19 : 18} align="center">
                        <h6>
                          <b>Data Not Found</b>
                        </h6>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
             sx={{ "& .MuiTablePagination-toolbar, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select": { fontSize: "13px", }, "& .MuiIconButton-root": { padding: "1px" }, "& svg": { fontSize: "17px" }, }}
              rowsPerPageOptions={paginationrowsPerPageOptions}
              count={totalRowsForActiveTab}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              component="div"
              colSpan={3}
              SelectProps={{ inputProps: { "aria-label": "rows per page" }, native: true }}
              ActionsComponent={TablePaginationActions}
            />
            
            {/* Shared per-row actions menu (Download / Send for Approval / Info / Calibration Time) */}
            <Menu anchorEl={rowMenuAnchorEl} open={Boolean(rowMenuAnchorEl)} onClose={closeRowMenu}
            sx={{ "& .MuiMenuItem-root": { fontSize: "13px", minHeight: "36px", padding: "6px 12px", }, "& .MuiSvgIcon-root": { fontSize: "17px", }, }}
            >
              {rowMenuTarget && (
                <MenuItem
                  component={Link}
                  to={`/datasheet/edit/${rowMenuTarget.id}/${rowMenuTarget.insId}/print`}
                  onClick={closeRowMenu}
                >
                  <DownloadIcon fontSize="small" style={{ marginRight: 8 }} />
                  Download Datasheet
                </MenuItem>
              )}
              {rowMenuTarget && !DISABLED_MODULE?.includes("locationTracking") && (
                <MenuItem
                  onClick={() => {
                    handleInfoOpenModal(rowMenuTarget);
                    closeRowMenu();
                  }}
                >
                  <InfoIcon fontSize="small" style={{ marginRight: 8 }} />
                  Info
                </MenuItem>
              )}
              {rowMenuTarget && settingList["CalibrationStartEndtime"]?.toLowerCase() === "true" && (
                <MenuItem
                  onClick={() => {
                    handleCalibrationTimeOpenModal(rowMenuTarget);
                    closeRowMenu();
                  }}
                >
                  <WatchLaterIcon fontSize="small" style={{ marginRight: 8 }} />
                  Calibration Activity
                </MenuItem>
              )}
            </Menu>
          </Box>
        </>
      )}

      {isModalInfoOpen && <InfoModal open={isModalInfoOpen} handleClose={handleInfoCloseModal} info={infoModalData} allUsers={usersArray} />}
      
      <CalibrationStartEndTimeModal
        open={isCalibrationTimeModalOpen}
        handleClose={handleCalibrationTimeCloseModal}
        datasheetDetails={calibrationTimeModalData}
        allUsers={usersArray}
      />
    </ListWrap>
  );
}